<template>
  <component
    :to="to"
    :is="to ? 'router-link' : 'div'"
    @click="!to && $emit('cardClicked')"
  >
    <div
      class="card"
      style="height: 7.8rem; border-radius:16px;"
      :style="bgColor"
    >
      <div class="card-body p-20 d-flex align-items-center col-gap-2">
        <div class="icon-container rounded-pill" :style="iconColor">
          <slot name="icon" />
        </div>
        <div class="d-flex flex-column " :style="textStyle">
          <p class="font-22 font-weight-bold mb-0">{{ title }}</p>
          <p class="font-14 font-weight-normal mb-0">
            {{ label }}
          </p>
        </div>
      </div>
    </div>
  </component>
</template>

<script>
export default {
  name: "IconCard",
  props: {
    bgColor: String,
    iconColor: String,
    label: [String, Number],
    title: [String, Number],
    to: String,
    textStyle: {
      type: String,
      default: "row-gap: 10px;",
    },
  },
};
</script>

<style scoped>
.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  width: 70px;
  height: 70px;
}
</style>
